/**
 * This function sleeps for a given time
 * @module sleep
 * @param {ms} ms - a number in milliseconds
 * @return {promise} {Promise} blocking async promise
 * @example
 *
 *  await sleep(1000) // sleeps for 1 second
 *
 */
export const sleep = async (ms: number): Promise<any> => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};
